/* eslint-disable eqeqeq */
import React, {
  memo,
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Button, Spinner } from "react-bootstrap";
import Tables from "../../../Reuseable/Tables";
import { api } from "../../../../Services/api";
import "react-confirm-alert/src/react-confirm-alert.css";
import BlockIcon from "@mui/icons-material/Block";
import {
  setAllTrackings,
  setFetchedAllTrackingsList,
  setStartAllTrekId,
  setAllTaskSelectedProject,
  setAllTaskView,
  setFilters,
} from "../../../../redux/Tracking/actionCreator";
import { ConfirmationBox } from "../../../Reuseable/ConfimationBox";
import norecordsvg from "../../../../assets/images/norecord.svg";
import greenIcon from "../../../../assets/images/icons/green.png";
import redIcon from "../../../../assets/images/red.png";
import yellowIcon from "../../../../assets/images/icons/yellow.png";
import CopyIcon from "../../../../assets/images/icons/copy.svg";
import Copy from "copy-to-clipboard";

import TrackingModalView from "./style";
import { TrackingView } from "./TrackingView";
import { TrackingListHeader } from "./TrackingListHeader";
import { TrackingListColumns } from "./TrackingListColumns";
import { NewTracking } from "../NewTracking";
import { Clone } from "./Clone";
import NoDataFound from "./NoDataFound";
import { v4 as uuid } from "uuid";
import { AddNewProject } from "../Projects/AddNewProject";
import { useSessionStorage } from "react-use";
import usePrevious from "../../../../Hooks/usePrevious";
import useTrackingItemData from "../../../../Hooks/useTrackingItemData";
import { useDelete } from "../../../../Hooks/useDelete";
import { useFetch } from "../../../../Hooks/useFetch";
import { key } from "../../../../data/queryKeys";
import trashIcon from "../../../../assets/images/icons/bluedelete12.svg";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Pagination } from "antd";
// Ant Design Pagination removed - using custom Gmail-style pagination

const Tracking = ({ permission, backlogsPermission }) => {
  // Deadline signal filter state
  const [deadlineSignalFilter, setDeadlineSignalFilter] = useState(null);
  const editPermission = permission?.edit;
  const createPermission = permission?.create;
  const deletePermission = permission?.delete;
  const [count, setCount] = useState(0);

  const trackingClientId = useSelector(
    (state) => state.Auth.user.trackingclientid,
  );

  const checkIconStyle = {
    color: "#4EB6EE",
    fontSize: "14px",
    marginTop: "-2%",
    paddingRight: "2px",
  };
  const copytextStyle = {
    color: "#4EB6EE",
    fontSize: "10px",
    padding: "3px",
  };

  /**************************for all projects*********************************/
  const { data: allProjectsRes, isLoading: allProjectsLoading } = useFetch(
    key.get_all_projects,
    `/trackingprojects/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allProjectsData = allProjectsRes?.data?.Items ?? [];
  /**************************for all members*********************************/
  const { data: allProjectMembers } = useFetch(
    key.get_all_members,
    `/trackingusers/memberlist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allMembers = allProjectMembers?.data ?? [];
  /******************************all Task Types*****************************/
  const { data: allTasksTypesRes } = useFetch(
    key.get_all_tasktypes,
    "/trackingtasktype",
    () => {},
    () => {},
    false,
    false,
  );
  let allTasksTypes = allTasksTypesRes?.data ?? [];
  /****************************all workflows*******************************/
  const { data: allProjectWorkflowRes } = useFetch(
    key.get_all_workflow,
    `/trekrworkflow`,
    () => {},
    () => {},
    false,
    false,
  );

  let allWorkFlow = allProjectWorkflowRes?.data?.workflowList ?? [];
  /***********************************************************************************/

  const fetchedAllTrackings = useSelector(
    (state) => state.Tracking.fetchedAllTrackings,
  );
  let allTrackingsList = useSelector((state) => state.Tracking.allTrackings);

  const [getallchecked, setGetAllChecked] = useState([]);

  let myTrackingList = useSelector((state) => state.Tracking.myTrackings);
  const allFlowStatus = useSelector((state) => state.Tracking.allFlowStatus);
  console.log("allFlowStatus", allFlowStatus);
  let Work_Flow = Object.keys(allWorkFlow).map((key) => allWorkFlow[key]);
  const user = useSelector((state) => state.Auth.user);
  const authToken = useSelector((state) => state.Auth.authToken);
  const filters = useSelector((state) => state.Tracking.filters);
  let isFiltered = useSelector((state) => state.Tracking.isFiltered);
  const childARef = useRef();

  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);

  const [fileLoading, setFileLoading] = useState(false);
  const [showAlertBox, setShowAlertBox] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const [showView, setShowView] = useState(false);
  const [trackingItemData, setTrackingItemData] = useTrackingItemData();
  const [deleteConfirmationShow, setDeleteConfirmationShow] = useState(false);
  const [clonetaskData, setCloneTask] = useState({});
  const [filterDataLoading, setFilterDataLoading] = useState(false);

  /****************date filter**************/
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  let taskview = useSelector((state) => state.Tracking.allTaskView);

  const isProjectExist = (project) => {
    const result = allProjectsData.find(
      // eslint-disable-next-line eqeqeq
      (e) => e.trackingprojectid == project || e.number == project,
    );
    return result !== undefined ? true : false;
  };

  const handleSearch = (value) => {
    setSearchValue(value);
  };

  const dispatch = useDispatch();

  const [trackingSortings, setTrackingSorting] = useState({
    selectedSortingItem: "trackingid",
    trackingNumberSorting: "down",
    statusSorting: "",
    typeSorting: "",
    projectNameSorting: "",
    reportedBySorting: "",
    prioritySorting: "",
    assignedToSorting: "",
    expectedDeadlineSorting: "",
  });

  const [trackingFilters, setTrackingFilters] = useState({
    projectsFilter: [],
    typeFilter: [],
    assignedtoFilter: [],
    statusFilter: [],
    priorityFilter: [],
    reportedByFilter: [],
  });

  const selected_menu = "all_tasks";
  const [changeInForm, setChangeInForm] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [viewTaskData, setViewTaskData] = useState({});
  const [taskfile, setTaskFile] = useState("");
  const [taskfileList, setTaskFileList] = useState("");
  const [taskfileType, setTaskFileType] = useState("");
  const [showEditTask, setShowEditTask] = useState("");
  const [updatedData, setUpdatedData] = useSessionStorage(
    "trackingUpdatedData",
    {},
  );
  const [allTrackingData, setAllTrackingData] = useState([]);
  const [taskHistory, setHistory] = useState("");
  const [showClone, setShowClone] = useState(false);
  const [trackingLoading, setTrackingLoading] = useState(false);
  const startAllTrackingId = useSelector(
    (state) => state.Tracking.startAllTrackingId,
  );
  const selectedProject = useSelector(
    (state) => state.Tracking.allTaskSelectedProject,
  );
  const [cardui] = useSessionStorage("List", "List");

  const [allcheckTable, setAllCheckTable] = useState([]);
  const [selectAllTasks, setSelectAllTasks] = useState(false);
  const childRef = useRef();
  const [currentEnd, setCurrentEnd] = useState(moment()?.endOf("month"));

  const RANGE = 3;
  const startDate = moment(currentEnd)
    .subtract(2 - 1, "months")
    .startOf("month");
  const goBack = () => {
    setCurrentEnd((prev) =>
      moment(prev)
        .subtract(3 - 1, "months")
        ?.endOf("month"),
    );
  };

  const goForward = () => {
    setCurrentEnd((prev) =>
      moment(prev)
        .add(3 - 1, "months")
        ?.endOf("month"),
    );
  };

  console.log("1e3r4", startDate, currentEnd);

  const handleTasksHeaderCheckbox = () => {
    if (selectAllTasks) {
      setAllCheckTable([]);
    } else {
      const allRowIndexes = allTrackingsList.map((item, index) => ({
        item,
        index,
      }));
      setAllCheckTable(allRowIndexes);
    }
    setSelectAllTasks((prevSelectAll) => !prevSelectAll);
  };

  const handleMoveCheckboxTable = (item, index) => {
    if (allcheckTable.some((row) => row.index === index)) {
      setAllCheckTable((prevSelectedRows) =>
        prevSelectedRows.filter((row) => row.index !== index),
      );
    } else {
      setAllCheckTable((prevSelectedRows) => {
        if (!Array.isArray(prevSelectedRows)) {
          prevSelectedRows = [];
        }
        return [...prevSelectedRows, { item, index }];
      });
    }
  };

  const handleClick = () => {
    setCount(count + 1);
  };

  // Function to handle "Go Back" - clear all filters and show all data
  const handleGoBack = () => {
    setTrackingFilters({
      projectsFilter: [],
      assignedtoFilter: [],
      typeFilter: [],
      statusFilter: [],
      priorityFilter: [],
      reportedByFilter: [],
    });
    setFromDate("");
    setToDate("");
    dispatch(
      setFilters({
        projects: [],
        assignedTo: [],
        type: [],
        reportedBy: [],
        status: [],
        priority: [],
      }),
    );
    // Reset pagination state
    dispatch(setStartAllTrekId(null));
    // The filter system will handle the API call automatically
  };

  useEffect(() => {
    setTimeout(() => {
      setAlertMessage("");
      setShowAlertBox(false);
    }, 2500);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setAlertMessage("");
      setShowAlertBox(false);
    }, 2500);
  }, [showAlertBox]);

  useEffect(() => {
    setViewTaskData((prevState) => {
      return {
        ...prevState,
        title: trackingItemData?.title,
        projectid: trackingItemData?.trackingprojectsid,
        taskType: trackingItemData?.type,
        assignedTo: trackingItemData?.assignedto,
        priority: trackingItemData?.priority,
        status: trackingItemData?.trackingprojectstatusid,
        description: trackingItemData?.description,
        timeline: trackingItemData?.timeline,
        fileurls: trackingItemData?.fileurls,
        filesize: trackingItemData?.filesize ?? [],
        fileArray: [],
        eta: trackingItemData?.eta,
        deadline: trackingItemData?.deadline,
        raiseflag: trackingItemData?.raiseflag || [],
      };
    });
    setCloneTask((prevState) => {
      return {
        ...prevState,
        title: trackingItemData?.cloneTitle,
        assignedto: "",
      };
    });
    setUpdatedData((prevState) => {
      return {
        ...prevState,
        title: trackingItemData?.title,
        description: trackingItemData?.description,
        fileurls: trackingItemData?.fileurls,
        timeline: trackingItemData?.timeline,
        filesize: trackingItemData?.filesize,
      };
    });
  }, [trackingItemData]);

  useEffect(() => {
    if (selected_menu === "all_tasks") {
      setShowFilter(true);
      // Initialize with empty arrays to ensure proper format for MultiSelect
      setTrackingFilters({
        projectsFilter: [],
        assignedtoFilter: [],
        typeFilter: [],
        statusFilter: [],
        priorityFilter: [],
        reportedByFilter: [],
      });
    } else {
      setShowFilter(false);
      setTrackingFilters({});
    }
  }, [selected_menu]);

  // Trigger initial filter API call when component mounts
  useEffect(() => {
    if (selected_menu === "all_tasks" && showFilter) {
    }
  }, [selected_menu, showFilter]);

  useEffect(() => {
    if (!loading && !fetchedAllTrackings) {
      setLoading(true);
    }
  }, []);

  const previousProject =
    usePrevious(selectedProject) || allProjectsData?.trackingprojectid;
  const project = isProjectExist(selectedProject)
    ? selectedProject
    : previousProject || allProjectsData?.trackingprojectid;

  const refreshAllTracking = () => {
    fetchTrackingsList("refresh");
  };

  const onFetchTrackingsSuccess = (response) => {
    if (response?.data) {
      dispatch(setAllTrackings([...response.data]));
      setLoading(false);
      setTrackingLoading(false);
      dispatch(setFetchedAllTrackingsList(true));
      if (response.LastEvaluatedKey) {
        dispatch(setStartAllTrekId(response.LastEvaluatedKey.trackingid));
      } else {
        dispatch(setStartAllTrekId("none"));
      }
    } else {
      setTrackingLoading(false);
      setLoading(false);
      dispatch(setAllTrackings([]));
      dispatch(setFetchedAllTrackingsList(true)); // Mark as fetched even if no data
    }
  };

  // Remove the useFetch hook and use manual fetch for initial load
  const {
    refetch: refetchAllTrackings,
    // isFetched,
    isFetching: istrackingloading,
  } = useFetch(
    "allTrackings",
    `/tracking/${trackingClientId}?lastEvaluatedKey=null&limit=10&fromdate=${startDate?.format(
      "YYYY-MM-DD",
    )}&todate=${currentEnd?.format("YYYY-MM-DD")}`,
    onFetchTrackingsSuccess,
    () => {
      // Error callback - ensure loading states are reset
      setLoading(false);
      setTrackingLoading(false);
      dispatch(setFetchedAllTrackingsList(true));
    },
    false,
    true,
  );

  console.log(istrackingloading, "istrackingloading");

  useEffect(() => {
    refetchAllTrackings();
  }, [currentEnd]);

  const fetchTrackingsList = async (fetchtype) => {
    setTrackingLoading(true);
    setLoading(true);
    const limitNo = startAllTrackingId === "none" ? null : startAllTrackingId;
    try {
      // let url = `/tracking/${trackingClientId}?lastEvaluatedKey=${limitNo}&limit=10`;
      let url = `/tracking/${trackingClientId}?lastEvaluatedKey=null&limit=10&fromdate=${startDate?.format(
        "YYYY-MM-DD",
      )}&todate=${currentEnd?.format("YYYY-MM-DD")}`;
      const response = await api.get(url, {
        headers: {
          authorizationtoken: ` ${authToken}`,
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
        },
      });
      setTrackingLoading(false);
      setLoading(false);
      if (response.data.status) {
        if (selected_menu === "all_tasks") {
          if (response.data.data) {
            if (fetchtype === "refresh") {
              dispatch(setAllTrackings([...response.data.data]));
            } else {
              dispatch(setAllTrackings([...response.data.data]));
            }
            // Only set fetchedAllTrackings to true when we have data
            dispatch(setFetchedAllTrackingsList(true));
          } else {
            // No data returned, but still mark as fetched
            dispatch(setAllTrackings([]));
            dispatch(setFetchedAllTrackingsList(true));
          }
          if (response.data.LastEvaluatedKey) {
            dispatch(
              setStartAllTrekId(response.data.LastEvaluatedKey.trackingid),
            );
          } else {
            dispatch(setStartAllTrekId("none"));
          }
        }
      } else {
        // API returned error status
        dispatch(setAllTrackings([]));
        dispatch(setFetchedAllTrackingsList(true));
      }
    } catch (error) {
      setLoading(false);
      setTrackingLoading(false);
      dispatch(setAllTrackings([]));
      dispatch(setFetchedAllTrackingsList(true));
      setAllTaskSelectedProject(
        previousProject || allProjectsData?.trackingprojectid,
      );
    }
  };

  const pageSize = 500;
  const [page, setPage] = useState(1);

  const chunkArray = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size),
    );

  // const chunks = chunkArray(allTrackingData || [], pageSize);
  // const paginatedData = chunks[page - 1] || [];

  console.log(allTrackingData, "allTrackingDataallTrackingData");
  useEffect(() => {
    setPage(1);
  }, [trackingFilters?.typeFilter]);

  const { chunks, paginatedData } = useMemo(() => {
    // :one: Filter data
    const filteredData = (allTrackingData || []).filter((item) => {
      if (
        !trackingFilters?.typeFilter ||
        trackingFilters.typeFilter.length === 0
      )
        return true;
      return true;
    });
    const chunked = chunkArray(filteredData, pageSize);

    const currentPageIndex = Math.min(page - 1, chunked.length - 1);
    const currentPageData = chunked[currentPageIndex] || [];

    return {
      chunks: chunked,
      paginatedData: currentPageData,
    };
  }, [allTrackingData, trackingFilters?.typeFilter, page]);

  useEffect(() => {
    if (!fetchedAllTrackings && !trackingLoading && !loading) {
      setTrackingLoading(true);
      setLoading(true);
      fetchTrackingsList("refresh");
    }
  }, [fetchedAllTrackings, trackingLoading, loading]);

  useEffect(() => {
    if (allTrackingsList.length === 0) {
      dispatch(setStartAllTrekId(null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allTrackingsList]);

  const refreshfiles = (item) => {
    fetchFileData(item);
  };

  const taskViewRender = (value) => {
    dispatch(setAllTaskView(value));
  };

  const fetchFileData = (item) => {
    for (let i = 0; i < item?.fileurls?.length; i++) {
      setFileLoading(true);
      api
        .get(
          `tracking/fileupload/${trackingClientId}/${item.trackingid}/${item.fileurls[i]}`,
        )
        .then((response) => {
          if (response) {
            let Filename = item.fileurls[i];
            setTaskFile((prevfiles) => [...prevfiles, response.data.url]);
            setTaskFileType((prevfiles) => [
              ...prevfiles,
              Filename.split(".").pop(),
            ]);
            setTaskFileList((prevfiles) => [...prevfiles, Filename]);
            setFileLoading(false);
          } else {
            console.error("Error");
          }
        });
    }
  };

  const { data: allProjectModalsRes } = useFetch(
    key.get_project_modal_value,
    `/projectmodellist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allProjectModals = allProjectModalsRes?.data ?? [];

  let ProjectModoptions = [];
  if (allProjectModals.length > 0) {
    allProjectModals.forEach((item) =>
      ProjectModoptions.push({
        label: item.ModelTitle,
        id: item.ProjectModelId,
      }),
    );
  }

  let AllProjects = [];
  if (allProjectsData.length > 0) {
    allProjectsData.forEach((element) => {
      AllProjects.push({
        label: element?.label,
        id: element.trackingprojectid,
      });
    });
  }

  // Helper to get deadline signal for a row
  const getDeadlineSignal = (item) => {
    const deadline = moment(item.deadline, [
      "DD/MM/YYYY, HH:mm",
      "DD/MM/YYYY, hh:mm A",
      "DD/MM/YYYY, hh:mm a",
      moment.ISO_8601,
    ]);
    const originalDeadline = moment(item.originaldeadline, [
      "DD/MM/YYYY, HH:mm",
      "DD/MM/YYYY, hh:mm A",
      "DD/MM/YYYY, hh:mm a",
      moment.ISO_8601,
    ]);
    const now = moment();
    const status = item.status_name && item.status_name[0];
    let color = "";
    if (!status) return null;
    if (status !== "Closed") {
      if (deadline.isBefore(now)) {
        color = "red";
      } else {
        color = "yellow";
      }
    } else {
      if (moment(originalDeadline).isBefore(moment(deadline))) {
        color = "green";
      } else if (deadline.isSame(originalDeadline)) {
        color = "green";
      } else {
        color = "red";
      }
    }
    return color;
  };
  const getData = (data) => {
    const result = data
      ?.sort((item1, item2) => {
        if (trackingSortings.selectedSortingItem === "priority") {
          if (trackingSortings.prioritySorting) {
            if (trackingSortings.prioritySorting === "down") {
              if (item1.priority < item2.priority) return 1;
              else return -1;
            } else {
              if (item1.priority < item2.priority) return -1;
              else return 1;
            }
          }
        } else if (trackingSortings.selectedSortingItem === "project") {
          if (trackingSortings.projectNameSorting) {
            if (trackingSortings.projectNameSorting === "down") {
              if (item1.project_name < item2.project_name) return 1;
              else return -1;
            } else {
              if (item1.project_name < item2.project_name) return -1;
              else return 1;
            }
          }
        } else if (trackingSortings.selectedSortingItem === "reportedby") {
          if (trackingSortings.reportedBySorting) {
            if (trackingSortings.reportedBySorting === "down") {
              if (item1.reportedByName < item2.reportedByName) return 1;
              else return -1;
            } else {
              if (item1.reportedByName < item2.reportedByName) return -1;
              else return 1;
            }
          }
        } else if (trackingSortings.selectedSortingItem === "status") {
          if (trackingSortings.statusSorting) {
            if (trackingSortings.statusSorting === "down") {
              if (item1.status_name < item2.status_name) return 1;
              else return -1;
            } else {
              if (item1.status_name < item2.status_name) return -1;
              else return 1;
            }
          }
        } else if (trackingSortings.selectedSortingItem === "assignedto") {
          if (trackingSortings.assignedToSorting) {
            if (trackingSortings.assignedToSorting === "down") {
              if (item1.assignedtoName < item2.assignedtoName) return 1;
              else return -1;
            } else {
              if (item1.assignedtoName < item2.assignedtoName) return -1;
              else return 1;
            }
          }
        } else if (trackingSortings.selectedSortingItem === "type") {
          if (trackingSortings.typeSorting) {
            if (trackingSortings.typeSorting === "down") {
              if (item1.taskName < item2.taskName) return 1;
              else return -1;
            } else {
              if (item1.taskName < item2.taskName) return -1;
              else return 1;
            }
          }
        } else if (
          trackingSortings.selectedSortingItem === "expectedDeadline"
        ) {
          if (trackingSortings.expectedDeadlineSorting) {
            const d1 = moment(
              item1.expectedDeadline || item1.deadline,
            ).valueOf();
            const d2 = moment(
              item2.expectedDeadline || item2.deadline,
            ).valueOf();
            // Put empty values at the bottom
            if (!d1) return 1;
            if (!d2) return -1;
            if (trackingSortings.expectedDeadlineSorting === "down") {
              return d1 < d2 ? 1 : -1; // Descending
            } else {
              return d1 < d2 ? -1 : 1; // Ascending
            }
          }
        } else {
          if (trackingSortings.trackingNumberSorting) {
            if (trackingSortings.trackingNumberSorting === "down") {
              if (parseInt(item1.trackingid) < parseInt(item2.trackingid))
                return 1;
              else return -1;
            } else {
              if (parseInt(item1.trackingid) < parseInt(item2.trackingid))
                return -1;
              else return 1;
            }
          }
        }
      })
      .filter((item) => {
        // Filter by deadline signal if selected
        if (deadlineSignalFilter) {
          const signal = getDeadlineSignal(item);
          if (signal !== deadlineSignalFilter) return false;
        }
        return true;
      })
      .filter((item) => {
        console.log("ihjhjhjjhjjj", item);
        console.log("selected_menu12");

        if (selected_menu === "my_tasks")
          return (
            item.status_name !== "Deployed" && item.status_name !== "Verified"
          );
        else {
          console.log("itemitem", item);
          return item;
        }
      })
      // .filter((item) => {
      //   return allProjectsData.find((e) => e.trackingprojectid === item.trackingprojectsid) //? only show the tasks which are in the projects
      // })
      .filter((item) => {
        let trackingnumber = trackingClientId + "-" + item.trackingid;
        let trackingnumber1 = trackingClientId + item.trackingid;
        return (
          String(item.trackingid) === searchValue ||
          trackingnumber.toLowerCase().includes(searchValue.toLowerCase()) ||
          trackingnumber1.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.title.toLowerCase().includes(searchValue.toLowerCase())
        );
      })
      // .filter((item) => {
      //   if (
      //     trackingFilters.projectsFilter &&
      //     trackingFilters.projectsFilter.length > 0 &&
      //     selected_menu === "all_tasks"
      //   ) {
      //     let filterdData = trackingFilters.projectsFilter.filter((element) =>
      //       element.value === item.trackingprojectsid ? true : false,
      //     );
      //     if (filterdData.length > 0) return item;
      //     else return false;
      //   } else return item;
      // })

      .filter((item) => {
        const dataTwo = trackingFilters.projectsFilter.some((items) => {
          const data = item?.trackingprojectid === items?.value;
          if (data.length > 0) {
            return data;
          }
        });
        if (
          trackingFilters.projectsFilter &&
          trackingFilters.projectsFilter.length > 0 &&
          selected_menu === "all_tasks"
        ) {
          return trackingFilters.projectsFilter.some(
            (filterItem) =>
              String(filterItem.value) === String(item.trackingprojectsid),
          );
        }

        return true;
      })
      .filter((val) => {
        if (
          fromDate &&
          toDate &&
          fromDate !== "Invalid date" &&
          toDate !== "Invalid date"
        ) {
          if (val.reporteddate && val.reporteddate.length) {
            const ReportedDate = new Date(val.reporteddate);
            const formattedDate = ReportedDate.toLocaleDateString("en-US");
            if (
              moment(formattedDate).isBetween(fromDate, toDate, "day", "[]")
            ) {
              return val;
            }
          }
        } else {
          return val;
        }
      })
      .filter((val) => {
        if (fromDate && fromDate !== "Invalid date") {
          if (val.reporteddate && val.reporteddate.length) {
            const ReportedDate = new Date(val.reporteddate);
            const formattedDate = ReportedDate.toLocaleDateString("en-US");
            if (moment(formattedDate).isSameOrAfter(fromDate, "day")) {
              return val;
            }
          }
        } else {
          return val;
        }
      })
      .filter((val) => {
        if (toDate && toDate !== "Invalid date") {
          if (val.reporteddate && val.reporteddate.length) {
            const ReportedDate = new Date(val.reporteddate);
            const formattedDate = ReportedDate.toLocaleDateString("en-US");
            if (moment(formattedDate).isSameOrBefore(toDate, "day")) {
              return val;
            }
          }
        } else {
          return val;
        }
      })
      .filter((item) => {
        if (
          trackingFilters.typeFilter &&
          trackingFilters.typeFilter.length > 0 &&
          selected_menu === "all_tasks"
        ) {
          let filterdData = trackingFilters.typeFilter.filter((element) =>
            element.value == item.type ? true : false,
          );
          if (filterdData.length > 0) return item;
          else return false;
        } else return item;
      })
      .filter((item) => {
        if (
          trackingFilters.assignedtoFilter &&
          trackingFilters.assignedtoFilter.length > 0 &&
          selected_menu === "all_tasks"
        ) {
          let filterdData = trackingFilters.assignedtoFilter.filter(
            (element) => (element.value === item.assignedto ? true : false),
          );
          if (filterdData.length > 0) return item;
          else return false;
        } else return item;
      })
      .filter((item) => {
        if (
          trackingFilters.statusFilter &&
          trackingFilters.statusFilter.length > 0
        ) {
          console.log(
            "trackingFilters.statusFilter12",
            trackingFilters.statusFilter,
          );
          let filterdData = trackingFilters.statusFilter.filter((element) => {
            if (element?.label === "No Status") {
              console.log("element-->", element.label, item?.status_name?.[0]);
              return item?.status_name?.[0] === undefined;
            } else {
              return element?.label === item?.status_name?.[0];
            }
          });
          if (filterdData.length > 0) return item;
          else return false;
        } else return item;
      })
      .filter((item) => {
        console.log(item, "valueudadfate", trackingFilters);
        if (
          trackingFilters.priorityFilter &&
          trackingFilters.priorityFilter.length > 0 &&
          selected_menu === "all_tasks"
        ) {
          let filterdData = trackingFilters.priorityFilter.filter((element) =>
            element.value?.toLowerCase() === item.priority?.toLowerCase()
              ? true
              : false,
          );
          if (filterdData.length > 0) return item;
          else return false;
        } else return item;
      })
      .filter((item) => {
        if (
          trackingFilters.reportedByFilter &&
          trackingFilters.reportedByFilter.length > 0 &&
          selected_menu === "all_tasks"
        ) {
          let filterdData = trackingFilters.reportedByFilter.filter(
            (element) => (element.value === item.reportedby ? true : false),
          );
          if (filterdData.length > 0) return item;
          else return false;
        } else return item;
      })
      .filter((item) => {
        let trackingnumber = trackingClientId + "-" + item.trackingid;
        let trackingnumber1 = trackingClientId + item.trackingid;
        return (
          trackingnumber.toLowerCase().includes(searchValue.toLowerCase()) ||
          trackingnumber1.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.title.toLowerCase().includes(searchValue.toLowerCase())
        );
      })
      .map((item, i) => {
        let project_name = allProjectsData.find(
          (e) => e.trackingprojectid === item.trackingprojectsid,
        );
        if (project_name) {
          item.project_name = project_name.label;
        } else {
          // Fallback: try to find by number as well
          project_name = allProjectsData.find(
            (e) => e.number === item.trackingprojectsid,
          );
          if (project_name) {
            item.project_name = project_name.label;
          } else {
            item.project_name = "-";
          }
        }

        let workflowId = allProjectsData.find(
          (e) =>
            e.trackingprojectid == item.trackingprojectsid ||
            e.number == item.trackingprojectsid,
        );
        if (workflowId) item.workflowId = workflowId.workflow;

        // Use the same pattern as other components for consistent status mapping
        const Work_Flow = Object.values(allWorkFlow).flatMap((obj) =>
          Object.values(obj),
        );
        let workflow = Work_Flow.find((e) => e.workFlowId == item.workflowId);
        if (workflow) item.workflow = workflow?.workFlow;

        const statusName =
          item?.workflow && item?.workflow[item.trackingprojectstatusid]
            ? item?.workflow[item.trackingprojectstatusid]
            : "";
        item.status_name = statusName ? Object.values(statusName) : "";
        let reportedByName = allMembers.find(
          (e) => e.userId === item.reportedby,
        );
        if (reportedByName) item.reportedByName = reportedByName.personname;
        let assignedto = allMembers.find((e) => e.userId === item.assignedto);
        if (assignedto) item.assignedtoName = assignedto.personname;
        else item.assignedtoName = "Not Assigned";
        let task = allTasksTypes.find((e) => e.id == item.type);
        if (task) item.taskName = task.label;
        item.cloneTitle = "Clone - " + item.title;

        item.reporteddate = moment(item.reporteddate).format(
          "MMM D, YYYY h:mm A",
        );

        const handleCopyIcon = (e) => {};

        const copyTicketNumber = (e) => {
          var text = trackingClientId + "-" + item.trackingid;
          Copy(text);
        };

        return (
          <tr
            key={i}
            val={item}
            onClick={(e) => {
              taskViewRender("taskview");
              setTrackingItemData(
                (selected_menu === "all_tasks"
                  ? allTrackingsList
                  : myTrackingList
                ).find((element) => element.trackingid === item.trackingid),
              );
              // resetState();
            }}
          >
            <td>
              <input
                type="checkbox"
                name="group1"
                className="table_check_box"
                onChange={() => handleMoveCheckboxTable(item, i)} // Wrap the function call inside an arrow function
                checked={allcheckTable?.some((row) => row.index === i)}
                onClick={(e) => e.stopPropagation()}
              />
            </td>

            <td>
              <strong className="mobHead">Tracking No. : </strong>
              <span
                className="tracking-id"
                onClick={(e) => {
                  setTrackingItemData(
                    (selected_menu === "all_tasks"
                      ? allTrackingsList
                      : myTrackingList
                    ).find((element) => element.trackingid === item.trackingid),
                  );
                  fetchFileData(item);
                }}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                {/* Tracking No */}
                <span>
                  {trackingClientId}-{item.trackingid}
                </span>

                {/* Blocker Icon */}
                {item.priority === "blocker" || item.priority === "blocker2" ? (
                  <BlockIcon
                    className="block-icon"
                    style={{
                      cursor: "pointer",
                      color: "red",
                      fontSize: "17px",
                      marginTop: "2px",
                    }}
                  />
                ) : null}

                {/* Copy Icon */}
                <OverlayTrigger
                  trigger="click"
                  rootClose={false}
                  placement="top"
                  overlay={
                    <Popover style={copytextStyle}>
                      <CheckCircleIcon style={checkIconStyle} />
                      Copied
                    </Popover>
                  }
                >
                  <img
                    src={CopyIcon}
                    height={15}
                    width={15}
                    alt="copyIcon"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      copyTicketNumber();
                    }}
                  />
                </OverlayTrigger>
              </span>
            </td>

            <td>
              <strong className="mobHead">Project Name : </strong>

              <span>{item.project_name}</span>
            </td>
            <td>
              <strong className="mobHead">Title : </strong>
              <span>{item.title}</span>
            </td>
            <td className="text-capitalize">
              <strong className="mobHead">Status : </strong>
              <span>{item.status_name}</span>
            </td>
            <td>
              <strong className="mobHead">Priority : </strong>
              <span className="text-capitalize">
                {item.priority === "blocker" ||
                item.priority === "blocker1" ||
                item.priority === "blockerlevel1" ||
                item.priority === "Blocker Level 1"
                  ? "Blocker Level 1"
                  : item.priority === "blocker2" ||
                      item.priority === "blocker2" ||
                      item.priority === "blockerlevel2" ||
                      item.priority === "Blocker Level 2"
                    ? "Blocker Level 2"
                    : item.priority === "major" || item.priority === "Major"
                      ? "Major"
                      : item.priority === "medium" || item.priority === "Medium"
                        ? "Medium"
                        : item.priority === "minor" || item.priority === "Minor"
                          ? "Low"
                          : item.priority === ""
                            ? "-"
                            : item.priority}
              </span>
            </td>
            <td>
              <strong className="mobHead">Expected SLA : </strong>
              <span>
                {item.eta === "" || item.eta == null
                  ? "-"
                  : `${item.eta.toString().replace(/hrs?/i, "").trim()} hrs`}
              </span>
            </td>
            <td>
              <strong className="mobHead">Expected Deadline: </strong>
              <span>
                {console.log("itemdeadline", item.deadline)}
                {item.deadline === ""
                  ? "-"
                  : moment(item.deadline, [
                      "DD-MM-YYYY HH:mm",
                      "DD/MM/YYYY, HH:mm",
                      "DD/MM/YYYY, hh:mm A",
                      "DD/MM/YYYY, hh:mm a",
                      moment.ISO_8601,
                    ]).format("MMM D, YYYY hh:mm A")}
              </span>
            </td>
            {
              <td className="text-capitalize">
                <strong className="mobHead">Assigned To : </strong>
                <span>
                  {item.assignedto !== ""
                    ? item.assignedtoName
                    : "Not Assigned"}
                </span>
              </td>
            }
            <td className="text-center">
              <strong className="mobHead">Deadline signal : </strong>
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                {/* {(() => {
                  const deadline = moment(item.deadline);
                  const originalDeadline = moment(item.originaldeadline);
                  const now = moment();
                  const status = item.status_name[0]; // first element of status array
                  const diffInMinutes = deadline.diff(now, "minutes");
                  let color = "";
                  let text = "";

                  // Task not closed
                  if (status !== "Closed") {
                    if (deadline.isBefore(now)) {
                      // ❌ already exceeded
                      color = "red";
                      text = "RED";
                    } else {
                      // 🟡 not exceeded yet
                      color = "yellow";
                      text = "YELLOW";
                    }
                  }

                  // Task closed
                  if (status === "Closed") {
                    if (moment(originalDeadline).isBefore(moment(deadline))) {
                      color = "green";
                      text = "GREEN";
                    } else if (deadline.isSame(originalDeadline)) {
                      color = "green";
                      text = "GREEN";
                    } else {
                      color = "red";
                      text = "RED";
                    }
                  }

                  if (!color) return null;

                  // Assign imgSrc AFTER color is defined
                  const imgSrc =
                    color === "green"
                      ? greenIcon
                      : color === "yellow"
                        ? yellowIcon
                        : redIcon;

                  return (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <img
                        src={imgSrc}
                        alt={text}
                        style={{ width: "16px", height: "16px" }}
                      />
                      <span>{text}</span>
                    </span>
                  );
                })()} */}
                {/* {(() => {
                  const deadline = moment(item.deadline);
                  const newval = item;
                  const originalDeadline = moment(item.ClosedTime);
                  const now = moment();
                  const status = item.status_name[0]?.trim().toLowerCase(); // first element of status array
                  const diffInMinutes = deadline.diff(now, "minutes");

                  let color = "";
                  let text = "";
                  console.log(
                    item.ClosedTime,
                    "originalDeadline",
                    item.deadline,
                  );
                  // if (deadline.isAfter(now)) {
                  //   console.log("deadline,", deadline);
                  //   color = "yellow";
                  //   text = "YELLOW";
                  // }
                  if (originalDeadline) {
                    if (originalDeadline.isAfter(deadline)) {
                      console.log("deadline,", deadline);
                      color = "red";
                      text = "RED";
                    } else if (originalDeadline.isSame(deadline)) {
                      color = "green";
                      text = "GREEN";
                    } else {
                      if (
                        (status === "closed" || status === "completed") &&
                        originalDeadline.isBefore(deadline)
                      ) {
                        console.log("originalDeadline12", item.ClosedTime);
                        color = "green";
                        text = "GREEN";
                      } else if (
                        (status !== "closed" || status !== "completed") &&
                        originalDeadline.isBefore(deadline)
                      ) {
                        color = "yellow";
                        text = "YELLOW";
                      } else {
                        color = "yellow";
                        text = "YELLOW";
                      }
                    }
                  } else {
                    if (deadline.isAfter(now)) {
                      console.log("deadline,", now);
                      color = "red";
                      text = "RED";
                    } else if (deadline.isSame(now)) {
                      color = "green";
                      text = "GREEN";
                    } else {
                      if (
                        (status === "closed" || status === "completed") &&
                        deadline.isBefore(now)
                      ) {
                        console.log("deadline12", item.ClosedTime);
                        color = "green";
                        text = "GREEN";
                      } else if (
                        (status !== "closed" || status !== "completed") &&
                        deadline.isBefore(now)
                      ) {
                        color = "yellow";
                        text = "YELLOW";
                      } else {
                        color = "yellow";
                        text = "YELLOW";
                      }
                    }
                  }

                  const imgSrc =
                    color === "green"
                      ? greenIcon
                      : color === "yellow"
                        ? yellowIcon
                        : color === "red"
                          ? redIcon
                          : "";

                  return (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      {imgSrc ? (
                        <>
                          <img
                            src={imgSrc}
                            alt={text}
                            style={{ width: "16px", height: "16px" }}
                          />
                          <span>{text}</span>
                        </>
                      ) : (
                        "-"
                      )}
                    </span>
                  );
                })()} */}
                {(() => {
                  const deadlineFormats = [
                    "DD-MM-YYYY HH:mm",
                    "DD/MM/YYYY, HH:mm",
                    "DD/MM/YYYY, hh:mm A",
                    "DD/MM/YYYY, hh:mm a",
                    moment.ISO_8601,
                  ];
                  const hasDeadline =
                    item.deadline !== undefined &&
                    item.deadline !== null &&
                    item.deadline !== "";
                  const deadline = hasDeadline
                    ? moment(item.deadline, deadlineFormats)
                    : null;
                  const closedTime = item.ClosedTime
                    ? moment(item.ClosedTime, deadlineFormats)
                    : null;
                  const now = moment();
                  const status = item.status_name?.[0]?.trim().toLowerCase();

                  let color = "";
                  let text = "";

                  // No usable deadline → no signal to compute
                  if (!deadline || !deadline.isValid()) {
                    color = "";
                    text = "";
                  }

                  // ================= CLOSED TASK LOGIC =================
                  else if (closedTime && closedTime.isValid()) {
                    // 🔴 Late
                    if (closedTime.isAfter(deadline)) {
                      color = "red";
                      text = "RED";
                    }
                    // 🟢 Exact time
                    else if (closedTime.isSame(deadline)) {
                      color = "green";
                      text = "GREEN";
                    }
                    // Closed before deadline
                    else {
                      if (status === "closed" || status === "completed") {
                        color = "green";
                        text = "GREEN";
                      } else {
                        color = "yellow";
                        text = "YELLOW";
                      }
                    }
                  }

                  // ================= NOT CLOSED YET =================
                  else {
                    // Deadline passed but not closed → 🔴 SLA BREACH
                    if (now.isAfter(deadline)) {
                      color = "red";
                      text = "RED";
                    }
                    // Still before deadline → 🟡 In progress
                    else {
                      color = "yellow";
                      text = "YELLOW";
                    }
                  }

                  return (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {color ? (
                        <>
                          <span className={`deadline-signal-dot is-${color}`} />
                          <span>{text}</span>
                        </>
                      ) : (
                        "-"
                      )}
                    </span>
                  );
                })()}

                {/* {(() => {
                  const deadline = moment(item.deadline);
                  const closedTime = moment(item.ClosedTime);
                  const status = item.status_name?.[0]?.trim().toLowerCase();

                  let color = "";
                  let text = "";

                  console.log(
                    "Deadline:",
                    item.deadline,
                    "Closed:",
                    item.ClosedTime,
                  );

                  // 🔴 Late: Closed after deadline
                  if (closedTime.isAfter(deadline)) {
                    color = "red";
                    text = "RED";
                  }

                  // 🟢 On time
                  else if (closedTime.isSame(deadline)) {
                    color = "green";
                    text = "GREEN";
                  }

                  // 🟡 Closed before deadline
                  else if (closedTime.isBefore(deadline)) {
                    if (status === "closed" || status === "completed") {
                      color = "green";
                      text = "GREEN";
                    } else {
                      color = "yellow";
                      text = "YELLOW";
                    }
                  }

                  return (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {color ? (
                        <>
                          <span className={`deadline-signal-dot is-${color}`} />
                          <span>{text}</span>
                        </>
                      ) : (
                        "-"
                      )}
                    </span>
                  );
                })()} */}
              </span>
            </td>

            {/* <td className="">
              <strong className="mobHead">Timeline : </strong>
              <span>{item.timeline ? item.timeline.concat(" Hr") : "-"}</span>
            </td> */}

            <td
              style={{ width: "300", whiteSpace: "nowrap" }}
              className="text-center"
            >
              {deletePermission && (
                <Button
                  size="sm"
                  variant="link"
                  className="text-decoration-none pe-1 ps-1"
                >
                  <img
                    alt="img"
                    src={trashIcon}
                    onClick={(e) => {
                      e.stopPropagation();
                      setDeleteConfirmationShow(true);
                      setTrackingItemData(item);
                    }}
                  />
                </Button>
              )}{" "}
            </td>
          </tr>
        );
      });
    return result;
  };

  const changesInList = useRef(null);

  const changesMade = () => {
    changesInList.current = uuid();
  };

  const deleteOnSuccess = (res) => {
    if (res?.status) {
      setShowAlertBox(true);
      taskViewRender("AllTask");
      let index = allTrackingsList.findIndex(
        (element) => element.trackingid === trackingItemData.trackingid,
      );
      if (index >= 0) {
        allTrackingsList.splice(index, 1);
      }
      changesMade();
      setAlertMessage("Selected item has been deleted successfully");
    }
  };

  const { mutate: deleteTask } = useDelete(
    "delete-task",
    "/tracking/" + trackingClientId,
    deleteOnSuccess,
    () => {},
  );

  const deleteConfimrationHandler = (response) => {
    if (response) {
      deleteTask(trackingItemData.trackingid);
    }
  };

  const showWorkFlow = allProjectsData?.find(
    (allProject) =>
      allProject.trackingprojectid === project || allProject.number == project,
  )?.workflow;

  const workflow = Work_Flow?.find(
    // eslint-disable-next-line eqeqeq
    (flow) => flow[0].workFlowId == showWorkFlow,
  );

  useEffect(() => {
    setAllTrackingData(getData(allTrackingsList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    allTrackingsList,
    project,
    workflow,
    changesInList.current,
    searchValue,
    trackingFilters,
    trackingSortings,
    fromDate,
    toDate,
    allcheckTable,
    allMembers,
    allWorkFlow,
    trackingClientId,
    allTasksTypes,
    deadlineSignalFilter,
  ]);

  if (taskview === "add project") {
    return (
      <AddNewProject
        setProjectView={taskViewRender}
        get
        setShowAlertBox={setShowAlertBox}
        setAlertMessage={setAlertMessage}
        onTaskView={false}
        taskViewPanel="AllTask"
      />
    );
  }

  if (taskview === "addnew") {
    return (
      createPermission && (
        <NewTracking
          setTaskview={taskViewRender}
          setShowAlertBox={(val) => setShowAlertBox(val)}
          setAlertMessage={(val) => setAlertMessage(val)}
          refreshAllTracking={refreshAllTracking}
          setLoading={(val) => setLoading(val)}
          loading={loading}
          defaultProjectid={project}
        />
      )
    );
  }
  const showInitialLoading =
    trackingLoading && !fetchedAllTrackings && allTrackingsList?.length === 0;

  if (showInitialLoading) {
    return (
      <div className="text-center mt-5 mb-5">
        <Spinner animation="border" variant="info" />
      </div>
    );
  }

  // Check if any filter is applied
  const isFilterActive =
    trackingFilters?.projectsFilter?.length > 0 ||
    trackingFilters?.assignedtoFilter?.length > 0 ||
    trackingFilters?.typeFilter?.length > 0 ||
    trackingFilters?.statusFilter?.length > 0 ||
    trackingFilters?.priorityFilter?.length > 0 ||
    trackingFilters?.reportedByFilter?.length > 0 ||
    fromDate ||
    toDate;
  // Check if there are no results - only show when we've actually fetched data and it's empty
  const hasNoResults =
    fetchedAllTrackings &&
    !loading &&
    !trackingLoading &&
    allTrackingsList?.length === 0;

  // Show loading spinner when we have no data and we're either loading or haven't fetched yet
  if (
    allTrackingsList?.length === 0 &&
    (loading || trackingLoading) &&
    !fetchedAllTrackings
  ) {
    return (
      <div className="text-center mt-5 mb-5">
        <Spinner animation="border" variant="info" />
      </div>
    );
  }

  if (hasNoResults) {
    return (
      <>
        <TrackingListHeader
          selected_menu={selected_menu}
          allWorkFlowData={allWorkFlow}
          setAllTrackingData={setAllTrackingData}
          allTrackingsList={allTrackingsList}
          allcheckTable={allcheckTable}
          setAllCheckTable={setAllCheckTable}
          setAlertMessage={setAlertMessage}
          setShowAlertBox={setShowAlertBox}
          searchValue={searchValue}
          handleSearch={handleSearch}
          userRole={user.rolename}
          userRoleType={user.roletype}
          createPermission={createPermission}
          fetchAllTracking={isFiltered ? handleClick : fetchTrackingsList}
          refreshAllTracking={refreshAllTracking}
          setLoading={setLoading}
          loading={loading}
          trackingFilters={trackingFilters}
          setTrackingFilters={setTrackingFilters}
          data={allTrackingData}
          trackingData={allTrackingsList}
          setTaskview={taskViewRender}
          setFormType={() => {}}
          setChangeInForm={setChangeInForm}
          showFilter={showFilter}
          selectedProject={selectedProject}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
          backlogsPermission={backlogsPermission}
          handleGoBack={handleGoBack}
          deadlineSignalFilter={deadlineSignalFilter}
          setDeadlineSignalFilter={setDeadlineSignalFilter}
          counts={count}
          setFilterDataLoading={setFilterDataLoading}
          startDate={startDate}
          currentEnd={currentEnd}
          goForward={goForward}
          goBack={goBack}
        />
        <div
          className="nodata_content"
          style={{
            width: "100%",
            textAlign: "center",
            padding: "32px 0",
            background: "#cce6ff",
            borderRadius: "8px",
            fontSize: "18px",
            color: "#222",
          }}
        >
          No Trackings Found
        </div>
      </>
    );
  }

  return (
    <>
      <Modal
        show={taskview === "taskview" && trackingItemData}
        onHide={() => taskViewRender("AllTask")}
        size="xl"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <TrackingView
            allWorkFlow={allWorkFlow}
            setCloneTask={setCloneTask}
            fileLoading={fileLoading}
            setTaskview={taskViewRender}
            show={showView}
            setTaskFile={setTaskFile}
            setTaskFileType={setTaskFileType}
            taskfileType={taskfileType}
            setTrackingItemData={setTrackingItemData}
            taskfileList={taskfileList}
            setTaskFileList={setTaskFileList}
            taskfile={taskfile}
            refreshfiles={refreshfiles}
            setShowView={(value) => setShowView(value)}
            allTaskTypes={allTasksTypes}
            allProjectsData={allProjectsData}
            allMemberres={allMembers}
            allStatus={allFlowStatus}
            item={trackingItemData}
            data={viewTaskData}
            setViewTaskData={setViewTaskData}
            showEditTask={showEditTask}
            setShowEditTask={setShowEditTask}
            updatedData={updatedData}
            setUpdatedData={setUpdatedData}
            history={taskHistory}
            setHistory={setHistory}
            setShowClone={setShowClone}
            selected_menu={selected_menu}
            setDeleteConfirmationShow={setDeleteConfirmationShow}
            fetchFileData={fetchFileData}
            deletePermission={deletePermission}
            editPermission={editPermission}
            backlogsPermission={backlogsPermission}
            menu="alltask"
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={taskview === "Clone" && clonetaskData?.title !== undefined}
        onHide={() => taskViewRender("AllTask") && setShowClone(false)} // closes modal and goes back to table
        size="md"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {clonetaskData.title !== undefined && (
            <Clone
              showClone={showClone}
              setShowClone={setShowClone}
              item={trackingItemData}
              allTrackingsList={allTrackingsList}
              setShowAlertBox={setShowAlertBox}
              setAlertMessage={setAlertMessage}
              clonetaskData={clonetaskData}
              setCloneTask={setCloneTask}
              setTaskview={taskViewRender}
              backTo={"AllTask"}
              taskfile={taskfile}
              taskfileList={taskfileList}
              viewTaskData={viewTaskData}
            />
          )}
        </Modal.Body>
      </Modal>

      {allTrackingsList?.length > 0 ||
      (isFilterActive && allTrackingData?.length === 0) ||
      loading ||
      fetchedAllTrackings ? (
        <>
          {showAlertBox && (
            <Alert
              variant="success"
              className="text-center alert-sucess alert mt-3 mb-1"
              dismissible
              closeVariant="white"
              onClick={(e) => setShowAlertBox(false)}
            >
              {alertMessage}
            </Alert>
          )}
          <ConfirmationBox
            heading="Are you sure to delete this ?"
            hidePopup={(e) => setDeleteConfirmationShow(false)}
            show={deleteConfirmationShow}
            confirmationResponse={deleteConfimrationHandler}
          />
          {taskview === "AllTask" || taskview === "Clone" ? (
            <>
              {allProjectsLoading ? (
                cardui !== "List" && (
                  <div className="text-center mt-5 mb-5">
                    <Spinner animation="border" variant="info" />
                  </div>
                )
              ) : (
                <></>
              )}

              <TrackingModalView>
                {console.log(
                  selected_menu === "all_tasks" ? paginatedData : [],
                )}
                <div className="trackingPage mt-1">
                  {loading && (
                    <div className="position-relative">
                      <div
                        className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                          zIndex: 1000,
                          top: 0,
                          left: 0,
                        }}
                      >
                        <div className="text-center">
                          {/* <Spinner animation="border" variant="info" /> */}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="table_customization">
                    <Tables
                      trackingLoading={istrackingloading}
                      className="table_container_customization"
                      setDeleteConfirmationShow={setDeleteConfirmationShow}
                      fetchFileData={fetchFileData}
                      selected_menu={selected_menu}
                      setTaskview={taskViewRender}
                      setTrackingItemData={setTrackingItemData}
                      setShowEditTask={setShowEditTask}
                      deletePermission={deletePermission}
                      handleMoveCheckboxTable={handleMoveCheckboxTable}
                      allcheckTable={allcheckTable}
                      setAllCheckTable={setAllCheckTable}
                      setGetAllChecked={setGetAllChecked}
                      getallchecked={getallchecked}
                      setProjectTable={true}
                      filterDataLoading={filterDataLoading}
                      columns={
                        <TrackingListColumns
                          handleSearch={handleSearch}
                          trackingSortings={trackingSortings}
                          setTrackingSorting={setTrackingSorting}
                          setSelectAllTasks={setSelectAllTasks}
                          selectAllTasks={selectAllTasks}
                          handleTasksHeaderCheckbox={handleTasksHeaderCheckbox}
                        />
                      }
                      fetchAllTracking={
                        isFiltered ? handleClick : fetchTrackingsList
                      }
                      startTrackingId={
                        searchValue
                          ? "none"
                          : selected_menu === "all_tasks"
                            ? startAllTrackingId
                            : "none"
                      }
                      // data={
                      //   selected_menu === "all_tasks" ? allTrackingData : []
                      // }
                      data={selected_menu === "all_tasks" ? paginatedData : []}
                      // showInfiniteScroll={true}
                      setHistory={setHistory}
                      header={
                        <TrackingListHeader
                          selected_menu={selected_menu}
                          fetchTrackingsList={fetchTrackingsList}
                          allWorkFlowData={allWorkFlow}
                          setAllTrackingData={setAllTrackingData}
                          allTrackingsList={
                            selected_menu === "all_tasks"
                              ? allTrackingsList
                              : myTrackingList
                          }
                          allcheckTable={allcheckTable}
                          setAllCheckTable={setAllCheckTable}
                          setAlertMessage={setAlertMessage}
                          setShowAlertBox={setShowAlertBox}
                          searchValue={searchValue}
                          handleSearch={handleSearch}
                          userRole={user.rolename}
                          userRoleType={user.roletype}
                          createPermission={createPermission}
                          fetchAllTracking={
                            isFiltered ? handleClick : fetchTrackingsList
                          }
                          refreshAllTracking={refreshAllTracking}
                          setLoading={(val) => setLoading(val)}
                          loading={loading}
                          trackingFilters={trackingFilters}
                          setTrackingFilters={setTrackingFilters}
                          data={
                            selected_menu === "all_tasks" ? allTrackingData : []
                          }
                          trackingData={
                            selected_menu === "all_tasks"
                              ? allTrackingsList
                              : []
                          }
                          setTaskview={taskViewRender}
                          setFormType={() => {}}
                          setChangeInForm={setChangeInForm}
                          showFilter={showFilter}
                          selectedProject={selectedProject}
                          fromDate={fromDate}
                          toDate={toDate}
                          setFromDate={setFromDate}
                          setToDate={setToDate}
                          backlogsPermission={backlogsPermission}
                          handleGoBack={handleGoBack}
                          deadlineSignalFilter={deadlineSignalFilter}
                          setDeadlineSignalFilter={setDeadlineSignalFilter}
                          deletePermission={deletePermission}
                          counts={count}
                          setFilterDataLoading={setFilterDataLoading}
                          startDate={startDate}
                          currentEnd={currentEnd}
                          goForward={goForward}
                          goBack={goBack}
                        />
                      }
                      notfound={"No Trackings Found"}
                      loading={allProjectsLoading}
                      isFilterActive={isFilterActive}
                      tabletrackingLoading={trackingLoading}
                      tableloader={loading}
                      startDate={startDate}
                      currentEnd={currentEnd}
                    />
                    {/* <Pagination
                      showSizeChanger={false}
                      current={page}
                      total={allTrackingData.length}
                      pageSize={pageSize}
                      onChange={(p) => setPage(p)}
                    /> */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        // justifyContent: "flex-start",
                        justifyContent: "flex-end",
                        gap: "12px",
                        padding: "16px",
                        marginTop: "16px",
                      }}
                    >
                      <button
                        onClick={() => setPage(page - 1)}
                        disabled={page === 1}
                        style={{
                          backgroundColor: page === 1 ? "#e0e0e0" : "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "4px 10px",
                          cursor: page === 1 ? "not-allowed" : "pointer",
                          opacity: page === 1 ? 0.5 : 1,
                        }}
                      >
                        ← Prev
                      </button>

                      <span
                        style={{
                          fontSize: "14px",
                          color: "#666",
                          minWidth: "200px",
                          textAlign: "center",
                        }}
                      >
                        {allTrackingData.length === 0
                          ? "No records"
                          : `${(page - 1) * pageSize + 1} - ${Math.min(
                              page * pageSize,
                              allTrackingData.length,
                            )} of ${allTrackingData.length}`}
                      </span>

                      <button
                        onClick={() => setPage(page + 1)}
                        disabled={page * pageSize >= allTrackingData.length}
                        style={{
                          backgroundColor:
                            page * pageSize >= allTrackingData.length
                              ? "#e0e0e0"
                              : "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "4px 10px",
                          cursor:
                            page * pageSize >= allTrackingData.length
                              ? "not-allowed"
                              : "pointer",
                          opacity:
                            page * pageSize >= allTrackingData.length ? 0.5 : 1,
                        }}
                      >
                        {console.log(
                          page * pageSize,
                          "pagepagesize",
                          pageSize,
                          allTrackingData.length,
                        )}
                        Next →
                      </button>
                    </div>
                  </div>
                </div>
              </TrackingModalView>
            </>
          ) : null}
        </>
      ) : (
        !loading &&
        !isFilterActive &&
        fetchedAllTrackings &&
        allTrackingsList.length === 0 && (
          <NoDataFound
            setTaskview={taskViewRender}
            setProjectView={taskViewRender}
            changeInForm={changeInForm}
            setAlertMessage={setAlertMessage}
            setShowAlertBox={setShowAlertBox}
            setChangeInForm={setChangeInForm}
            addtask="add task"
            addAllTask={true}
            headcontent="You have not added any Task to your account."
            bodycontent="Add a new project or create a task for your team to work on."
            btncontent="task"
            img={norecordsvg}
          />
        )
      )}
    </>
  );
};

export default memo(Tracking);
